
// src/reducers/announce-reducer.js

import actions from '../actions'
import {
  FETCH_ANNOUNCE,
  FETCH_ANNOUNCE_REQUESTED,
  FETCH_ANNOUNCE_COMPLETED,
  FETCH_ANNOUNCE_FAILED,
  CLOSE_ANNOUNCE,
  OPEN_ANNOUNCE,
  CLEAR_ANNOUNCE,
} from '../actions/announce'
import maxBy from 'lodash/maxBy'
import moment from 'moment'
/*
 * isFetching: announces取得中のフラグ
 * announce: お知らせの配列
 * latest: お知らせの中でもっとも最大のstart_at
 * close: leftsidebarの「お知らせ」表示切り替え
 */
const initialState = {
  isFetching: false,
  announces: undefined,
  latest: undefined,
  close: true,
}

export default function announceReducer(state = initialState, action = {}) {
  switch(action.type) {
  case FETCH_ANNOUNCE_REQUESTED:
    return Object.assign({}, state, {
      isFetching: true,
    })

  case FETCH_ANNOUNCE_COMPLETED:
    const announces = action.results
    var latest = undefined
    if(announces && announces.length > 0){
      latest = moment(maxBy(announces, (announce)=> announce.start_at).start_at).format('YYYY-MM-DD HH:mm:SS')
    }
    return Object.assign({}, state, {
      isFetching: false,
      close: true,
      announces: announces,
      latest: latest
    })

  case FETCH_ANNOUNCE_FAILED:
    return Object.assign({}, state, {
      isFetching: false,
    })

  case CLOSE_ANNOUNCE:
    return Object.assign({}, state, {
      close: true
    })

  case OPEN_ANNOUNCE:
    return Object.assign({}, state, {
      close: false
    })

  case CLEAR_ANNOUNCE:
    return Object.assign({}, initialState)

  default:
    return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/announce-reducer.js